module.exports = __webpack_public_path__ + "static/media/gray-user-profile.835fc86c.svg";